import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type {
  StockRequestDTO,
  StockResponseDTO,
  StockSearchParams,
} from "../types/stock.types";

export const stockAdminService = {
  search: async (
    params?: StockSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<StockResponseDTO>> => {
    const response = await api.get<PageResponseDTO<StockResponseDTO>>(
      API_ENDPOINTS.STOCKS_ADMIN.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  create: async (data: StockRequestDTO): Promise<StockResponseDTO> => {
    const response = await api.post<StockResponseDTO>(
      API_ENDPOINTS.STOCKS_ADMIN.BASE,
      data,
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<StockResponseDTO> => {
    const response = await api.get<StockResponseDTO>(
      API_ENDPOINTS.STOCKS_ADMIN.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  update: async (
    id: number,
    data: StockRequestDTO,
  ): Promise<StockResponseDTO> => {
    const response = await api.put<StockResponseDTO>(
      API_ENDPOINTS.STOCKS_ADMIN.BY_ID(id),
      data,
    );
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.STOCKS_ADMIN.BY_ID(id));
  },
};
